import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/portfolio-dashboard/components/AboutSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/portfolio-dashboard/components/ContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/portfolio-dashboard/components/EducationSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/portfolio-dashboard/components/ExperienceSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/portfolio-dashboard/components/FooterSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/portfolio-dashboard/components/GitHubSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/portfolio-dashboard/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/portfolio-dashboard/components/PortfolioNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/portfolio-dashboard/components/ProjectsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/portfolio-dashboard/components/SkillsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CVModalProvider"] */ "/opt/build/repo/src/app/portfolio-dashboard/context/CVModalContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ViewCountProvider"] */ "/opt/build/repo/src/app/portfolio-dashboard/context/ViewCountContext.tsx");
